export const freewallEventsTableName = "freewall_events";
